import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=8a4d2824&scoped=true"
var script = {}
import style0 from "./CardActions.vue?vue&type=style&index=0&id=8a4d2824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4d2824",
  null
  
)

export default component.exports